import { render, staticRenderFns } from "./SeverityRadioGroup.vue?vue&type=template&id=5b5da83c"
import script from "./SeverityRadioGroup.vue?vue&type=script&lang=js"
export * from "./SeverityRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./SeverityRadioGroup.vue?vue&type=style&index=0&id=5b5da83c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports